import { createApp } from 'vue';
import MobileLoginQRModal from './MobileLoginQRModal.vue';
import MobileLoginQRInline from './MobileLoginQRInline.vue';
import { i18n } from '../../i18n';

const modalEl = document.getElementById('mobile-login-qr-modal');
if (modalEl) {
  createApp(MobileLoginQRModal).use(i18n).mount(modalEl);
}

// Inline embed (e.g. /welcome, profile) — renders the QR straight into the page section.
const inlineEl = document.getElementById('mobile-login-qr-inline');
if (inlineEl) {
  createApp(MobileLoginQRInline).use(i18n).mount(inlineEl);
}
